import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MaterialListTableComponent } from './material-list-table.component';
import { MatRowKeyboardSelectionModule } from '../../../../core/directive/mat-row-keyboard-selection.module';
import { ResizeColumnModule } from '../../../../core/directive/resize-column.module';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
  declarations: [MaterialListTableComponent],
  imports: [
    CommonModule,
    IonicModule,
    TranslateModule,
    MatTableModule,
    MatRowKeyboardSelectionModule,
    ResizeColumnModule,
    MatSortModule,
  ],
  exports: [MaterialListTableComponent],
  providers: [],
})
export class MaterialListTableModule {}
